export const propertyFormConceptionFields = {
    topsoilInGround: {
        value: '',
        coef: 0.20,
    },
    topsoilInSlab: {
        value: '',
        coef: 0.40,
    },
    simpleRoof: {
        value: '',
        coef: 0.95,
    },
    gravelledTerraceRoof: {
        value: '',
        coef: 0.70,
    },
    otherSurfaceType: {
        value: '',
        coef: 0.95,
    },
    extensiveGreenRoofThick: {
        value: '',
        coef: 0.60,
    },
    semiIntensiveGreenRoofThick: {
        value: '',
        coef: 0.40,
    },
    intensiveRoofingThick: {
        value: '',
        coef: 0.20,
    },
    semiPermeableCoating: {
        value: '',
        coef: 0.70,
    },
    topsoilOnSlabThickness: {
        value: '',
        coef: 0.20,
    },
    areaNotCollectedOrSelfManaged: {
        value: '',
        coef: 0.00,
    },
    surfaceDisconnect:{
        value: '',
    },
};
